'use client'

import { useEffect } from 'react'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }, reset: () => void }) {
	useEffect(() => {
		// Log to console so it surfaces in container logs; enrich with digest if present
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		console.error('[GlobalError]', { message: error?.message, stack: error?.stack, digest: (error as any)?.digest, react: (globalThis as any)?.React?.version })
	}, [error])

	return (
		<html>
			<body>
				<div style={{ padding: 16 }}>
					<h2>Something went wrong</h2>
					<button onClick={() => reset()}>Try again</button>
				</div>
			</body>
		</html>
	)
}
